import {
  SphereGeometry,
  Mesh,
  // Shape,
  // ExtrudeGeometry,
  Group,
  MeshLambertMaterial,
  Plane,
  Vector2,
  Vector3,
  Matrix4,
  } from "three";

  import {
    // acceleratedRaycast,
    // computeBoundsTree,
    // disposeBoundsTree,
    // CONTAINED,
    INTERSECTED,
    NOT_INTERSECTED,
  } from 'three-mesh-bvh';

export const IfcDrawingMixin = {
  created() {
    //cursor object
    let sphere_geom = new SphereGeometry( 0.1, 32, 16 );
    let sphere_mat = new MeshLambertMaterial( { color: 'red' } );
    this.cursor_sphere = new Mesh( sphere_geom, sphere_mat );
    this.cursor_sphere.name = "cursor";


    //zero plane
    this.zero_plane = new Plane(new Vector3(0, 0, 1), 0);
    this.zero_plane.name = "zero_plane";
    //fixed z plane
    this.fixed_z_plane = new Plane(new Vector3(0, 0, -1), this.fixed_z_value);
    this.fixed_z_plane.name = "fixed_z_plane";

    //handle object
    let sphere_geom2 = new SphereGeometry( 0.1, 32, 16 );
    let sphere_mat2 = new MeshLambertMaterial( { color: 'red' } );
    sphere_mat2.depthTest = false;
    // sphere_mat2.depthWrite = false;
    this.handle_sphere = new Mesh( sphere_geom2, sphere_mat2 );
    this.handle_sphere.renderOrder = 900;

    // add-handles object
    let sphere_mat3 = new MeshLambertMaterial( { color: 'yellow' } );
    sphere_mat3.depthTest = false;
    this.add_handle_sphere = new Mesh( sphere_geom2, sphere_mat3 );
    this.add_handle_sphere.renderOrder = 900;

    // magnetic point object
    let magnetic_sphere_mat = new MeshLambertMaterial( { color: 'blue' } );
    magnetic_sphere_mat.depthTest = false;
    this.magnetic_cursor_sphere = new Mesh( sphere_geom2, magnetic_sphere_mat );
    this.magnetic_cursor_sphere.renderOrder = 1000;
    this.magnetic_cursor_sphere.name = "magnetic_cursor";

  },
  watch: {
    fixed_z_value(val) {
      this.fixed_z_plane = new Plane(new Vector3(0, 0, -1), val);
      this.fixed_z_plane.name = "fixed_z_plane";
    },
    'edit_geometry_object.id'(val) {
      if (val !== -1) {
        this.addHandles(this.all_groups, this.edit_geom);
        this.raycast_object_name_cache = this.raycast_object.name;
        this.raycast_object = this.scene.getObjectByName('handle_group');
      } else {
        this.raycast_object = this.scene.getObjectByName(this.raycast_object_name_cache);
        this.removeObjectByName('handle_group', this.all_groups);
      }
    },
    magnetic_corner_test(val) {
      if (val) {
        this.startCursor();
      } else {
        this.endCursor();
      }
    }
  },
  computed: {
    is_edit_geom() {
      if (this.edit_geometry_object.id !== -1) {
        return true;
      } else {
        return false;
      }
    },
    edit_geom_active_handle() {
      if (this.edit_geom_point_index !== -1) {
        let handle_mesh = this.scene.getObjectByName(`handle_point_${this.edit_geom_point_index}`);
        return handle_mesh;
      } else {
        return false;
      }
    },
    edit_geom_active_handle_add() {
      if (this.edit_geom_point_index !== -1) {
        let handle_mesh = this.scene.getObjectByName(`handle_add_${this.edit_geom_point_index}`);
        return handle_mesh;
      } else {
        return false;
      }
    },
    edit_geom_active_handle_add_before() {
      if (this.edit_geom_point_index !== -1) {
        let index;
        if (this.edit_geom_point_index === 0) {
          index = this.edit_geom.points_x.length-1
        } else {
          index = this.edit_geom_point_index-1
        }
        let handle_mesh = this.scene.getObjectByName(`handle_add_${index}`);
        return handle_mesh;
      } else {
        return false;
      }
    },
    show_add_handles() {
      if (
        !this.create_geom_mode && 
        (!this.edit_geom.max_points || this.edit_geom.max_points > this.edit_geom.points_x.length)
        ) {
          return true;
        } else {
          return false;
        }
    },
  },
  methods: {
    // just show simple cursor
    startCursor() {
      this.scene.add( this.cursor_sphere );
      this.cursor.show = true;
      this.moving_point = this.cursor_sphere.position;
    },
    endCursor() {
      this.cursor.show = false;
      this.moving_point = false;
      this.removeObjectByName('cursor');
    },
    moveCursor(event) {
      this.mouse.x = (event.offsetX / this.size.width) * 2 - 1;
      this.mouse.y = -(event.offsetY / this.size.height) * 2 + 1;
      
      //update drawing cursor position
      this.raycaster.setFromCamera(this.mouse, this.camera);
      
      // magnetic points intersection
      let found_corner = this.magneticCorner();
      // end magnetic point intersection
      if (!found_corner) {
        this.raycaster.setFromCamera(this.mouse, this.camera);
        // this.raycaster.firstHitOnly = true;
        let intersected = [];

        if (!this.use_fixed_z && this.raycast_object) {
          intersected = this.raycaster.intersectObject(this.raycast_object, true);
        }
        // console.log(intersected);
        if (intersected.length !== 0) {
          this.cursor_sphere.position = intersected[0].point;
        } else if (this.use_fixed_z) {
          this.raycaster.ray.intersectPlane(this.zero_plane, this.cursor_sphere.position);
        } else {
          this.raycaster.ray.intersectPlane(this.fixed_z_plane, this.cursor_sphere.position);
        }
      }
    },
    // magnetic test
    magneticCorner(target_point) {
      // target point as Vector3
      let ret_val = false;
      // let sphereCollision = this.cursor_sphere;

      // sphereCollision.visible = false;

      let bvhMesh = this.points_helper_group.children[0];
      let inverseMatrix = new Matrix4();
      inverseMatrix.copy( bvhMesh.matrixWorld ).invert();
      this.raycaster.ray.applyMatrix4( inverseMatrix );
  
      let threshold = this.raycaster.params.Points.threshold;
      let localThreshold = threshold / ( ( bvhMesh.scale.x + bvhMesh.scale.y + bvhMesh.scale.z ) / 3 );
      let localThresholdSq = localThreshold * localThreshold;
  
      let { ray } = this.raycaster;
      let closestDistance = Infinity;
      bvhMesh.geometry.boundsTree.shapecast( {
        boundsTraverseOrder: box => {
  
          // traverse the closer bounds first.
          return box.distanceToPoint( ray.origin );
  
        },
        intersectsBounds: ( box, isLeaf, score ) => {
          // if we've already found a point that's closer then the full bounds then
          // don't traverse further.
          if ( score > closestDistance ) {
            return NOT_INTERSECTED;
  
          }
  
          box.expandByScalar( localThreshold );
          return ray.intersectsBox( box ) ? INTERSECTED : NOT_INTERSECTED;
  
        },
        intersectsTriangle: triangle => {
          let distancesToRaySq = ray.distanceSqToPoint( triangle.a );
          if ( distancesToRaySq < localThresholdSq ) {
  
            // track the closest found point distance so we can early out traversal and only
            // use the closest point along the ray.
            let distanceToPoint = ray.origin.distanceTo( triangle.a );
            if ( distanceToPoint < closestDistance ) {
              closestDistance = distanceToPoint;
              // sphereCollision.position.copy( triangle.a ).applyMatrix4( bvhMesh.matrixWorld );
              target_point.copy( triangle.a ).applyMatrix4( bvhMesh.matrixWorld );
              target_point.copy( triangle.a );
              // sphereCollision.visible = true;
              ret_val = true;
            }
  
          }
  
        },
      } );
      return ret_val;
    },

    // neu
    createGeometry(object, url, type, max_points) {
      console.log('ehererjk');
      this.create_geom_mode = true;
      let geom_type;
      if (type) {
        geom_type = type
      } else {
        geom_type = "Shape";
      }
      let geom_max_points;
      if (max_points) {
        geom_max_points = max_points;
      } else {
        geom_max_points = false;
      }
      let geom_min_points = 3;
      if (type === 'Tube') {
        geom_min_points = 2;
      }
      let new_geom = {
        normal: [0,0,1],
        offset: [0,0,0],
        points_x: [0],
        points_y: [0],
        points_z: [0],
        type: geom_type,
        max_points: geom_max_points,
        min_points: geom_min_points,
        path_length: 0,
      };
      if (type === 'ExtrudedShape') {
        new_geom.extrude_value = 14;
      }
      this.startEditGeometry(object, url, new_geom);
      this.edit_geom_point_index = 0;
      // set fixed z valu
      this.use_fixed_z = true;
      this.fixed_z_plane.constant = 0 + this.center_position.z;
    },
    startEditGeometry(object, url, new_geom) {
      // element data
      // this.edit_geometry_element = JSON.parse(JSON.stringify(this.active_tree_element_spatial_long))
      this.edit_geometry_object = JSON.parse(JSON.stringify(object));
      this.edit_geometry_object.url = url;
      // hide element id
      // -> visible
      // this.setCollectionObjects({collection_name: 'visible_elements', action: 'remove', ids_by_target: {elements: [this.edit_geometry_object.id]}});
      this.setCollectionObjects({collection_name: `visible_${this.edit_geometry_object.type}`, action: 'remove', ids_by_target: {[this.edit_geometry_object.type]: [this.edit_geometry_object.id]}});
      // -> selected
      this.setGroupIndicesByIds({name: 'selected', ids: []});
      // create new edit mesh
      // if new geometry
      if (new_geom) {
        this.edit_geom = new_geom;
      } else {
        this.edit_geom = JSON.parse(JSON.stringify(this.edit_geometry_object.geometry));
      }
      this.edit_unstaged_geometry = this.createUnstagedGeometry(this.edit_geom);

      // add magnetic cursor
      this.magnetic_cursor_sphere.visible = false;
      this.scene.add(this.magnetic_cursor_sphere);

      if (this.edit_unstaged_geometry) {
        this.edit_geom_mesh = this.createUnstagedGeometryMesh(this.edit_unstaged_geometry, this.edit_geometry_object, this.shape_material_edit, 'edit', 800);
        this.all_groups.add(this.edit_geom_mesh);
      }
    },
    endEditGeometry(save, plan_scale, url) {
      return new Promise(resolve => {
        // save edit_geom
        if (this.create_geom_mode) {
          this.deleteHandles();
          this.create_geom_mode = false;
          this.edit_geom_point_index = -1;
        }
        if (save) {
          this.saveGeometry(plan_scale, url).then(() => resolve());
        //   let update = {
        //     geometry: this.edit_geom,
        //   }
        //   if (!plan_scale && this.edit_geometry_object.type === 'elements') {
        //     update.unstaged = true;
        //   }
        //   this.updateUObject({
        //     url: url?url:[
        //       {[plan_scale?'plans':this.edit_geometry_object.type]: this.edit_geometry_object.id}
        //     ],
        //     url_prefix: url?'':`/projects/${this.project_id}/projectstructure`,
        //     update: update,
        //   }).then(() => {
        //     if (plan_scale) {
        //       console.log(this.$store.state.Ultra.plans[this.edit_geometry_object.id]);
        //     } else {
        //       // add unstaged id
        //       this.addUnstagedElementId({
        //         project_id: this.project_id,
        //         element_id: this.edit_geometry_object.id
        //       })
        //       // initialize mesh
        //       this.removeUnstagedElementMeshes (this.edit_geometry_object.id);
        //       this.initializeUnstagedElement(this.edit_geometry_object.id);
        //     }
        //     this.setCollectionObjects({collection_name: 'visible_elements', action: 'add', ids_by_target: {elements: [this.edit_geometry_object.id]}});
        //     this.setGroupIndicesByIds({name: 'selected', ids: [this.edit_geometry_object.id]});
        //     // remove edit mesh
        //     this.removeObjectByName(`edit_unstaged_${this.edit_geometry_object.id}`, this.all_groups)
        //     this.edit_geometry_object = {id: -1};
        //   })
        } else {
          this.setCollectionObjects({collection_name: `visible_${this.edit_geometry_object.type}`, action: 'add', ids_by_target: {[this.edit_geometry_object.type]: [this.edit_geometry_object.id]}});
          // this.setCollectionObjects({collection_name: 'visible_elements', action: 'add', ids_by_target: {elements: [this.edit_geometry_object.id]}});
          if (this.edit_geometry_object.type !== 'taktareashapes') {
            this.setGroupIndicesByIds({name: 'selected', ids: [this.edit_geometry_object.id]});
          }
          // remove magnetic cursor
          this.removeObjectByName('magnetic_cursor')
          // remove edit mesh
          this.removeObjectByName(`edit_unstaged_${this.edit_geometry_object.id}`, this.all_groups)
          this.edit_geometry_object = {id: -1};
          resolve();
        }
      })
    },
    saveGeometry(plan_scale, url) {
      return new Promise(resolve => {
        // save geometry
        let update = {
          geometry: this.edit_geom,
        }
        if (!plan_scale && this.edit_geometry_object.type === 'elements') {
          update.unstaged = true;
        }
        this.updateUObject({
          url: url?url:[
            {[plan_scale?'plans':this.edit_geometry_object.type]: this.edit_geometry_object.id}
          ],
          url_prefix: url?'':`/projects/${this.project_id}/projectstructure`,
          update: update,
        }).then(() => {
          if (plan_scale) {
            console.log(this.$store.state.Ultra.plans[this.edit_geometry_object.id]);
          } else if (this.edit_geometry_object.type === 'elements') {
            // add unstaged id
            this.addUnstagedElementId({
              project_id: this.project_id,
              element_id: this.edit_geometry_object.id
            })
            // initialize mesh
            this.removeUnstagedElementMeshes(this.edit_geometry_object.id); //remove old geometry
            this.initializeUnstagedElement(this.edit_geometry_object.id); //add new geometry
            // end edit
            this.endEditGeometry(false).then(() => resolve());
          } else { //taktareashapes
            this.removeUnstagedShapeMeshes(this.edit_geometry_object.id); //remove old geometry
            this.initializeTaktareashape(this.edit_geometry_object.id).then(() => { //add new geometry
              // end edit
              this.endEditGeometry(false).then(() => resolve());
            }); 
          }
        });
      })
    },
    updateMeshGeometry(mesh, geom) {
      mesh.geometry.dispose();
      mesh.geometry = this.createUnstagedGeometry(geom);
    },
    drawingMouseMove(event) {
      this.mouse.x = (event.offsetX / this.size.width) * 2 - 1;
      this.mouse.y = -(event.offsetY / this.size.height) * 2 + 1;

      //update drawing cursor position
      this.raycaster.setFromCamera(this.mouse, this.camera);
      // this.raycaster.firstHitOnly = true;
      let intersected = [];
      let raycasted_point = new Vector3();

      // magnetic points
      let found_magnetic_point = false;
      let magnetic_point = new Vector3();
      if (this.use_magnetic_points) {
        found_magnetic_point = this.magneticCorner(magnetic_point);
        // found_magnetic_point = false;
      }
      if (found_magnetic_point) {
        // set magnetic cursor 
        // twist coordinates :D
        this.magnetic_cursor_sphere.position.x = magnetic_point.x;
        this.magnetic_cursor_sphere.position.y = magnetic_point.z * -1;
        this.magnetic_cursor_sphere.position.z = magnetic_point.y;
        this.magnetic_cursor_sphere.visible = true;

        // set raycasted point
        // twist coordinates :D
        raycasted_point.x = magnetic_point.x;
        raycasted_point.y = magnetic_point.z * -1;
        raycasted_point.z = magnetic_point.y;
        if (this.use_fixed_z && this.edit_geom.points_x.length > 1) {
          raycasted_point.z = this.fixed_z_value;
        }
      }
      // do normal raycast if not found magnetic point
      else {
        // remove magnetic cursor
        this.magnetic_cursor_sphere.visible = false;

        this.raycaster.firstHitOnly = true; //needed?
        // reset raycaster
        if (this.use_magnetic_points) {
          let bvhMesh = this.points_helper_group.children[0];
          this.raycaster.ray.applyMatrix4( bvhMesh.matrixWorld );
        }

        if (!this.use_fixed_z && this.raycast_object) {
          intersected = this.raycaster.intersectObject(this.raycast_object, true);
        }

        if (intersected.length !== 0) {
          raycasted_point = intersected[0].point;
        } else if (this.use_fixed_z) {
          this.raycaster.ray.intersectPlane(this.fixed_z_plane, raycasted_point);
        } else {
          this.raycaster.ray.intersectPlane(this.zero_plane, raycasted_point);
        }
      }
      // adjust center model
      raycasted_point.x -= this.center_position.x
      raycasted_point.y -= this.center_position.y
      raycasted_point.z -= this.center_position.z

      // set geometry
      this.moveUnstagedGeometryPoint(this.edit_geom_mesh, this.edit_geom, this.edit_geom_point_index, raycasted_point);
      // move Handles
      this.moveHandles(raycasted_point);
      // update measure value
      let el = document.getElementById("scale_length_value");
      if (el) {
        el.innerHTML = this.calcPathLength(this.edit_geom).toFixed(2);
      }
    },
    drawingMouseUp() {
      if (this.edit_geom_point_index === -1 && this.intersected_id !== -1) {
        if (this.intersected_name.includes('handle_add')) {
          // insert new point
          let handle_add_mesh = this.scene.getObjectByName(`handle_add_${this.intersected_id}`);
          this.addUnstagedGeometryPoint(this.edit_geom_mesh, this.edit_geom, this.intersected_id, handle_add_mesh.position);
          this.refreshHandles();
        }
        // points cache
        let point_index = this.intersected_id;
        if (this.intersected_name.includes('handle_add')) {
          point_index = this.intersected_id + 1;
        }
        this.edit_geom_point_cache.x = this.edit_geom.points_x[point_index];
        this.edit_geom_point_cache.y = this.edit_geom.points_y[point_index];
        this.edit_geom_point_index = point_index;
        // set fixed z value
        let handle_mesh = this.scene.getObjectByName(`handle_point_${this.edit_geom_point_index}`);
        this.use_fixed_z = true;
        this.fixed_z_plane.constant = handle_mesh.position.z + this.center_position.z;
        this.fixed_z_value = handle_mesh.position.z + this.center_position.z;
      } else if (this.create_geom_mode && (!this.edit_geom.max_points || this.edit_geom.max_points > this.edit_geom_point_index+1)) {
       
        // first point get z-index
        if (this.edit_geom.points_x.length === 1) {
          this.edit_geom.offset[1] = this.edit_geom_active_handle.position.z;
          this.edit_geom_mesh.position.y = this.edit_geom_active_handle.position.z;
          this.fixed_z_plane.constant = this.edit_geom_mesh.position.y + this.center_position.z;
          this.fixed_z_value = this.edit_geom_mesh.position.y + this.center_position.z;
        }
        // insert new point
        this.addUnstagedGeometryPoint(this.edit_geom_mesh, this.edit_geom, this.edit_geom_point_index, this.edit_geom_active_handle.position);
        this.refreshHandles();

        this.edit_geom_point_index = this.edit_geom_point_index+1;
      } else if (this.create_geom_mode) {
        // end create mode beacause of max points
        this.create_geom_mode = false;
        // refresh handles
        this.refreshHandles();
        this.removeObjectByName('handle_group', this.all_groups);
        this.addHandles(this.all_groups, this.edit_geom);
        this.raycast_object = this.scene.getObjectByName('handle_group');

        this.edit_geom.path_length = this.calcPathLength(this.edit_geom).toFixed(2);
        this.magnetic_cursor_sphere.visible = false;
        this.edit_geom_point_index = -1;
      } else {
        this.edit_geom.path_length = this.calcPathLength(this.edit_geom).toFixed(2);
        this.magnetic_cursor_sphere.visible = false;
        this.edit_geom_point_index = -1;
      }
    },
    drawingKeyUp(event) {
      // editing point
      if (this.edit_geom_point_index !== -1) {
        let keep_editing = false;
        let endNewGeom = function(self) {
            if (self.edit_geom.points_x.length > self.edit_geom.min_points) { //has enough points
            // end new geoemtry
            // delete Point
            self.deleteUnstagedGeometryPoint(self.edit_geom_mesh, self.edit_geom, self.edit_geom_point_index);
            // delete handles
            self.deleteHandles();
            self.create_geom_mode = false;
            // refresh handles
            self.refreshHandles();
            } else {
              self.deleteHandles();
              self.create_geom_mode = false;
              self.endEditGeometry(false);
            }

        };
        let restorePoint = function(self) {
          // escape point editing restore point
          let index_cache = self.edit_geom_point_index;
          let handle_mesh_cache = self.scene.getObjectByName(`handle_point_${index_cache}`);
          handle_mesh_cache.position.x = self.edit_geom_point_cache.x;
          handle_mesh_cache.position.y = self.edit_geom_point_cache.y;
          self.moveHandles({x: self.edit_geom_point_cache.x, y: self.edit_geom_point_cache.y, z: self.edit_geom_active_handle_add.position.z});
          self.moveUnstagedGeometryPoint(self.edit_geom_mesh, self.edit_geom, index_cache, self.edit_geom_point_cache);
        };
        // editing point
        if (event.code === 'Backspace') {
          if (this.create_geom_mode) {
            if (this.edit_geom.points_x.length > 1) {
              //delete point and take point before
              this.deleteUnstagedGeometryPoint(this.edit_geom_mesh, this.edit_geom, this.edit_geom_point_index);
              // delete handles
              this.deleteHandles();
              this.edit_geom_point_index = this.edit_geom.points_x.length-1;
              keep_editing = true; 
            } else {
              //end new geom and end edit mode without saving
              endNewGeom(this);
            }
          } else if (this.edit_geom.points_x.length > this.edit_geom.min_points) {
            // only if geometry has more than min points
            // delete Point
            this.deleteUnstagedGeometryPoint(this.edit_geom_mesh, this.edit_geom, this.edit_geom_point_index);
            // delete handles
            this.deleteHandles();
          } else { //restore point
            restorePoint(this);
          }
        } else if (event.code === 'Escape') {
          if (this.create_geom_mode) {
            endNewGeom(this);
          } else {
            restorePoint(this);


          //             // if 
          // if (this.edit_geom.points_x.length < this.edit_geom.min_points) {
            
          // }
          }
        }
        if (!keep_editing) {
          this.edit_geom_point_index = -1;
        }
      }
    },
    addHandles(target, geometry) {
      let handle_group = new Group();
      handle_group.name = `handle_group`;
      let handle_points_group = new Group();
      handle_points_group.name = `handle_points_group`;
      handle_group.add(handle_points_group);
      let handle_add_group = new Group();
      handle_add_group.name = `handle_add_group`;
      handle_group.add(handle_add_group);
      for (let i = 0; i < geometry.points_x.length; i++) {
        // handle
        let handle_mesh = this.handle_sphere.clone();
        let point_x = geometry.points_x[i] + geometry.offset[0];
        let point_y = geometry.points_y[i] + geometry.offset[2];
        handle_mesh.position.set(point_x, point_y, geometry.offset[1]);
        //props for raycast and click
        handle_mesh.unstaged = true;
        handle_mesh.takting_id = i;
        handle_mesh.name = `handle_point_${i}`;
        handle_points_group.add(handle_mesh);

        if (this.show_add_handles) {
          //  handles for adding point
          let next_index;
          if (i === geometry.points_x.length-1) {
            next_index = 0;
          } else {
            next_index = i+1
          }
          let handle_mesh_add = this.add_handle_sphere.clone();
          let next_point_x = geometry.points_x[next_index] + geometry.offset[0];
          let next_point_y = geometry.points_y[next_index] + geometry.offset[2];
          let mid_point_x = (point_x + next_point_x) / 2;
          let mid_point_y = (point_y + next_point_y) / 2;
          handle_mesh_add.position.set(mid_point_x, mid_point_y, geometry.offset[1]);
          //props for raycast and click
          handle_mesh_add.unstaged = true;
          handle_mesh_add.takting_id = i;
          handle_mesh_add.name = `handle_add_${i}`;
          handle_add_group.add(handle_mesh_add);
        }
      }
      //center model
      // handle_group.position.set(this.center_position.x, this.center_position.y, this.center_position.z);
      handle_group.rotateX(Math.PI / -2); 
      target.add(handle_group);
    },
    moveHandles(raycasted_point) {
      // set point Handle
      // this.edit_geom_active_handle.position = raycasted_point;
      this.edit_geom_active_handle.position.set(raycasted_point.x, raycasted_point.y, raycasted_point.z);

      if (this.show_add_handles) {
        // set add handle
        let index_before;
        let index_after;
        if (this.edit_geom_point_index === 0) {
          index_before = this.edit_geom.points_x.length-1;
          index_after = this.edit_geom_point_index+1;
        } else if (this.edit_geom_point_index === this.edit_geom.points_x.length-1) {
          index_before = this.edit_geom_point_index-1;
          index_after = 0;
        } else {
          index_before = this.edit_geom_point_index-1;
          index_after = this.edit_geom_point_index+1;
        }
        let point_before = {x: this.edit_geom.points_x[index_before] + this.edit_geom.offset[0], y: this.edit_geom.points_y[index_before] + this.edit_geom.offset[2]};
        let point_after = {x: this.edit_geom.points_x[index_after] + this.edit_geom.offset[0], y: this.edit_geom.points_y[index_after] + this.edit_geom.offset[2]};
  
        let mid_point_before = {x: (point_before.x + raycasted_point.x) / 2, y: (point_before.y + raycasted_point.y) / 2, z: raycasted_point.z};
        let mid_point_after = {x: (point_after.x + raycasted_point.x) / 2, y: (point_after.y + raycasted_point.y) / 2, z: raycasted_point.z};
  
        // this.edit_geom_active_handle_add_before.position.x = mid_point_before.x;
        // this.edit_geom_active_handle_add_before.position.y = mid_point_before.y;
        // this.edit_geom_active_handle_add_before.position.z = mid_point_before.z;

        this.edit_geom_active_handle_add_before.position.set(mid_point_before.x, mid_point_before.y, mid_point_before.z);

        // this.edit_geom_active_handle_add.position.x = mid_point_after.x;
        // this.edit_geom_active_handle_add.position.y = mid_point_after.y;
        // this.edit_geom_active_handle_add.position.z = mid_point_after.z;

        this.edit_geom_active_handle_add.position.set(mid_point_after.x, mid_point_after.y, mid_point_after.z);

      }
    },
    deleteHandles() {
      // remove handles
      let handle_points_group = this.scene.getObjectByName('handle_points_group');
      this.removeObjectByName(`handle_point_${this.edit_geom_point_index}`, handle_points_group);
      // rename handles improvee!!??
      handle_points_group.children.forEach((handle_mesh, index) => {
        handle_mesh.name = `handle_point_${index}`;
        handle_mesh.takting_id = index;
      });

      if (this.show_add_handles) {
        // add handles
        let handle_add_group = this.scene.getObjectByName('handle_add_group');
        this.removeObjectByName(`handle_add_${this.edit_geom_point_index}`, handle_add_group);
        // rename handles improvee!!??
        handle_add_group.children.forEach((handle_mesh, index) => {
          handle_mesh.name = `handle_add_${index}`;
          handle_mesh.takting_id = index;
        });
  
        // adjust handle before
        let index_before;
        let point_index = this.edit_geom_point_index;
        if (this.edit_geom_point_index === 0) {
          index_before = this.edit_geom.points_x.length-1;
        } else if (this.edit_geom_point_index === this.edit_geom.points_x.length-1) {
          index_before = this.edit_geom_point_index-1;
        } else {
          index_before = this.edit_geom_point_index-1;
        }
        if (this.edit_geom_point_index > this.edit_geom.points_x.length-1) {
          point_index = 0;
        }
        let point_before = {x: this.edit_geom.points_x[index_before] + this.edit_geom.offset[0], y: this.edit_geom.points_y[index_before] + this.edit_geom.offset[2]};
        let point = {x: this.edit_geom.points_x[point_index] + this.edit_geom.offset[0], y: this.edit_geom.points_y[point_index] + this.edit_geom.offset[2]};
    
        let mid_point_before = {x: (point_before.x + point.x) / 2, y: (point_before.y + point.y) / 2, z:  this.edit_geom_active_handle_add_before.position.z};
  
        // this.edit_geom_active_handle_add_before.position = mid_point_before;

        this.edit_geom_active_handle_add_before.position.set(mid_point_before.x, mid_point_before.y, mid_point_before.z);
      }
    },
    refreshHandles() {
      this.removeObjectByName('handle_group', this.all_groups);
      this.addHandles(this.all_groups, this.edit_geom);
      this.raycast_object = this.scene.getObjectByName('handle_group');
    },
    resizeHandles() {
      let group = this.scene.getObjectByName('handle_group'); //performance boost? save handle group in data
      // console.log(group);
      // edit and add handles
      if (group) {
        let children = group.children;
        for (let i = 0; i < children.length; i++) {
          let handle_group_children = children[i].children;
          for (let j = 0; j < handle_group_children.length; j++) {
            let handle = handle_group_children[j];
            // console.log(handle);
            let factor;
            if ( this.camera.isOrthographicCamera ) {
      
              factor = ( this.camera.top - this.camera.bottom ) / this.camera.zoom;
      
            } else {
      
              // factor = handle.worldPosition.distanceTo( this.camera.position ) * Math.min( 1.9 * Math.tan( Math.PI * this.camera.fov / 360 ) / this.camera.zoom, 7 );
              factor = handle.position.distanceTo( this.camera.position ) * Math.min( 1.9 * Math.tan( Math.PI * this.camera.fov / 360 ) / this.camera.zoom, 7 );
      
            }
            let size = 0.07;
            handle.scale.set( 1, 1, 1 ).multiplyScalar( factor * size / 1 );
          }
        }
      }
      // magnetic cursor
      let factor;
      if ( this.camera.isOrthographicCamera ) {
        factor = ( this.camera.top - this.camera.bottom ) / this.camera.zoom;
      } else {

        // factor = handle.worldPosition.distanceTo( this.camera.position ) * Math.min( 1.9 * Math.tan( Math.PI * this.camera.fov / 360 ) / this.camera.zoom, 7 );
        factor = this.magnetic_cursor_sphere.position.distanceTo( this.camera.position ) * Math.min( 1.9 * Math.tan( Math.PI * this.camera.fov / 360 ) / this.camera.zoom, 7 );
      }
      let size = 0.07;
      this.magnetic_cursor_sphere.scale.set( 1, 1, 1 ).multiplyScalar( factor * size / 1 );
    },
    calcPathLength(geometry) {
      let sum_length = 0;
      if (geometry.points_x.length > 1) {
        for (let i = 1; i < geometry.points_x.length; i++) {
          let point_a = {x: geometry.points_x[i-1], y: geometry.points_y[i-1]};
          let point_b = {x: geometry.points_x[i], y: geometry.points_y[i]};
          let a;
          let b;
          let length;
          if (geometry.points_z) {
            point_a.z = geometry.points_z[i-1];
            point_b.z = geometry.points_z[i];
  
            a = new Vector3(point_a.x, point_a.y, point_a.z)
            b = new Vector3(point_b.x, point_b.y, point_b.z)
  
            length = a.distanceTo(b);
          } else {
            a = new Vector2(point_a.x, point_a.y)
            b = new Vector2(point_b.x, point_b.y)
  
            length = a.distanceTo(b);
          }
          sum_length += length;
        } 
      }
      return sum_length;
    },
}
}